export class Sets {
  constructor(private readonly _sets: any[]) {}

  cartesianProduct() {
    return this._sets.reduce(
      (a, b) =>
        a
          .map((x: any) => b.map((y: any) => x.concat([y])))
          .reduce((acc: any, val: any) => acc.concat(val)),
      [[]]
    );
  }
}
